<template>
  <el-dialog class="save-app-container" :title="dialogTitle" :visible="showStatus" append-to-body :close-on-click-modal="false" width="500px" top="15vh" @close="hidePopups()">
    <el-form ref="form" label-suffix=":" :model="form" :rules="rules" label-width="120px" label-position="top">
      <el-form-item class="form-item" label="用户名" prop="username">
        <el-input v-model="name" placeholder="请输入" disabled clearable></el-input>
      </el-form-item>
      <el-form-item class="form-item" label="旧密码" prop="oldPassword" autocomplete="new-password">
        <el-input v-model="form.oldPassword" placeholder="请输入" show-password clearable></el-input>
      </el-form-item>
      <el-form-item class="form-item" label="新密码" prop="newPassword">
        <el-input v-model="form.newPassword" placeholder="请输入" show-password clearable autocomplete="new-password"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel()">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" v-debounce="{ handler: confirm }">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { updatePassword } from '@/api/login';
export default {
  props: {
    dialogTitle: {
      type: String,
      default: '',
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    currentItem: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['name']),
  },
  data() {
    return {
      boxLoading: false,
      submitLoading: false,
      form: {
        oldPassword: undefined,
        newPassword: undefined,
      }, // 表单
      rules: {
        oldPassword: [{ required: true, message: '必填项', trigger: 'blur' }],
        newPassword: [{ required: true, message: '必填项', trigger: 'blur' }],
      }, // 表单验证
    };
  },
  watch: {
    showStatus(val) {
      if (val) {
        this.getData();
      }
    },
  },
  methods: {
    async getData() {
      try {
        this.boxLoading = true;

        this.boxLoading = false;
      } catch (error) {
        this.boxLoading = false;
      }
    },
    // 添加
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          updatePassword({ ...this.form, username: this.name })
            .then(async (response) => {
              this.$message.success({ title: '成功', message: response.message, duration: 2000 });
              this.hidePopups();
              await this.$store.dispatch('LogOut').then(() => {
                this.submitLoading = false;
                location.reload();
              });
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    hidePopups() {
      this.$emit('hidePopups');
      this.$refs.form.resetFields();
      Object.assign(this.$data.form, this.$options.data().form);
    },
    cancel() {
      this.hidePopups();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select {
  display: block;
}
/deep/ .el-date-editor.el-input {
  width: 100%;
}
/deep/ .el-form-item__label {
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/DialogUpdatePwd/index.vue